import { useState, useEffect } from 'react';
import api from '../services/apiService';
import { Helmet } from 'react-helmet';  // Import von React Helmet



export default function AttachmentList() {
  const [attachments, setAttachments] = useState([]);
  const [items, setItems] = useState([]);
  const [file, setFile] = useState(null);
  const [documentType, setDocumentType] = useState('invoice');
  const [selectedItemIds, setSelectedItemIds] = useState([]);

  useEffect(() => {
    fetchAttachments(documentType);
  }, [documentType]);

  useEffect(() => {
    fetchItems();
  }, []);

  const formatItemLabel = (item) => {
    const description = String(item?.description || '').trim();
    return description ? `${item.name} - ${description}` : item.name;
  };


  const fetchAttachments = async (docType) => {
    try {
      const response = await api.get(`/attachments/${docType}`);
      setAttachments(response.data);
    } catch (error) {
      console.error("Fehler beim Abrufen der Anhänge:", error);
      setAttachments([]); // ❗ Falls keine Anhänge gefunden, leere den State
    }
  };

  const fetchItems = async () => {
    try {
      const response = await api.get('/items');
      const sortedItems = [...response.data].sort((a, b) =>
        (a.name || '').localeCompare(b.name || '', 'de')
      );
      setItems(sortedItems);
    } catch (error) {
      console.error('Fehler beim Abrufen der Artikel:', error);
      setItems([]);
    }
  };

  const handleFileUpload = async () => {
    if (!file) return;
    const formData = new FormData();
    formData.append("file", file);
    formData.append("documentType", documentType);
    if (selectedItemIds.length) {
      formData.append("itemIds", JSON.stringify(selectedItemIds));
    }
  
    try {
      await api.post("/attachments", formData);
      setFile(null);
      setSelectedItemIds([]);
      fetchAttachments(documentType); // ✅ Anhänge nach Upload aktualisieren
    } catch (error) {
      console.error("Fehler beim Hochladen", error);
    }
  };

  const handleItemSelectionChange = (event) => {
    const selectedIds = Array.from(event.target.selectedOptions).map((option) => option.value);
    setSelectedItemIds(selectedIds);
  };

  const handleDelete = async (id) => {
    try {
      await api.delete(`/attachments/${id}`);
      fetchAttachments(documentType); // ✅ Nach Löschen neu laden
    } catch (error) {
      console.error("Fehler beim Löschen", error);
    }
  };

  return (
    
    <div
      className="p-4"
      style={{
        width: '100%',
        maxWidth: '1200px',
        margin: '0 auto'
      }}
    >
      <Helmet>
        <title>Anhänge verwalten</title>
        <meta name="description" content="Anhänge verwalten" />
      </Helmet>
      <h1 className="text-xl font-bold mb-4">Anhänge verwalten</h1>
      <div className="p-4 border border-gray-300 rounded-md">
        <input type="file" onChange={(e) => setFile(e.target.files[0])} />
        <select 
        value={documentType} 
        onChange={(e) => setDocumentType(e.target.value)}
        style={{ marginLeft: '0px' }}
        >
          <option value="invoice">Rechnung</option>
          <option value="offer">Angebot</option>
          <option value="order">Auftrag</option>
        </select>
        <select
          multiple
          value={selectedItemIds}
          onChange={handleItemSelectionChange}
          style={{
            display: 'block',
            margin: '10px 0 0 0',
            width: '100%',
            minHeight: '140px'
          }}
        >
          {items.map((item) => (
            <option key={item.id} value={item.id}>
              {formatItemLabel(item)}
            </option>
          ))}
        </select>
        <div style={{ marginTop: '8px', fontSize: '14px', color: '#555' }}>
          Keine Auswahl = immer anhängen. Mehrfachauswahl = Anhang wird versendet, sobald mindestens einer der gewählten Artikel im Dokument vorkommt.
        </div>
        <div style={{ marginTop: '4px', fontSize: '13px', color: '#777' }}>
          Ausgewählt: {selectedItemIds.length}
        </div>
        <button 
        onClick={handleFileUpload} 
        className="p-2 bg-blue-500 text-white rounded"
        style={{
          padding: '10px 12px',
          background: '#28a745', // Grün für Hinzufügen
          color: '#fff',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
          marginTop: '10px',
          marginBottom: '20px' 
        }}
        >
          Hochladen
        </button>
      </div>

      <table className="mt-6 w-full border-collapse border border-gray-300">
        <thead>
          <tr className="border border-gray-300">
            <th className="border border-gray-300 p-2">Dateiname</th>
            <th className="border border-gray-300 p-2">Artikel</th>
            <th className="border border-gray-300 p-2">Vorschau</th>
            <th className="border border-gray-300 p-2">Aktionen</th>
          </tr>
        </thead>
        <tbody>
        {attachments.map((attachment) => {
            // Option 2: Hier wird der Preview-Link mit dem Axios-Basis-URL erstellt
            const fileName = attachment.filepath.split('/').pop();
            const previewUrl = `${api.defaults.baseURL}/attachments/preview/${fileName}`;
            return (
              <tr key={attachment.id} className="border border-gray-300">
                <td className="border border-gray-300 p-2">{attachment.filename}</td>
                <td className="border border-gray-300 p-2">
                  {attachment.itemNames?.length ? attachment.itemNames.join(', ') : 'Alle Artikel'}
                </td>
                <td className="border border-gray-300 p-2">
                  {attachment.filename.endsWith('.pdf') ? (
                    <a 
                      href={previewUrl} 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="text-blue-500"
                    >
                      PDF anzeigen
                    </a>
                  ) : attachment.filename.match(/\.(jpg|jpeg|png|gif)$/) ? (
                    <img 
                      src={previewUrl} 
                      alt="Vorschau" 
                      className="h-16" 
                    />
                  ) : (
                    "Keine Vorschau verfügbar"
                  )}
                </td>
                <td className="border border-gray-300 p-2">
                  <button 
                    onClick={() => handleDelete(attachment.id)}
                    style={{
                      fontSize: '15px',
                      padding: '5px 10px',
                      background: '#dc3545',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '5px',
                      cursor: 'pointer'
                    }} 
                    className="p-1 bg-red-500 text-white rounded"
                  >
                    Löschen
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
